module.exports = __webpack_public_path__ + "img/house8b.3e324abe.jpg";